<template>
  <section>
    <div class="tw-text-right">
      <v-btn-toggle mandatory small v-model="innerValue">
        <v-btn v-if="show24" :value="24" small>24 Hours</v-btn>
        <v-btn :value="168" small>7 Days</v-btn>
        <v-btn :value="336" small>14 Days</v-btn>
<!--        <v-menu :close-on-content-click="false">-->
<!--          <template v-slot:activator="{ on }">-->
<!--            <v-btn small v-on="on">Custom</v-btn>-->
<!--          </template>-->
<!--          <div>-->
<!--            <v-date-picker v-model="customDateRange" range />-->
<!--            <div class="tw-text-right">-->
<!--              <v-btn>Update</v-btn>-->
<!--            </div>-->
<!--          </div>-->
<!--        </v-menu>-->
      </v-btn-toggle>
      <p class="caption tw-mt-2">{{ displayedTimeText }}</p>
    </div>
    <v-skeleton-loader v-if="loading" type="image" />
    <v-sheet v-else>
      <e-chart :options="options" autoresize class="tw-w-full" />
    </v-sheet>
  </section>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'TheTabRecentBasicChart',
  props: {
    latestTime: {
      type: String
    },
    show24: {
      type: Boolean,
      default: true
    },
    value: {
      type: Number
    },
    options: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    innerValue: {
      get () {
        return this.value
      },
      set (newValue) {
        return this.$emit('input', newValue)
      }
    },
    displayedTimeText () {
      const now = this.latestTime ? dayjs(this.latestTime) : dayjs()
      const nowText = now.format(this.$config.dateFormat + ' HH:00')
      console.log(nowText)
      const startTimeText = now
        .subtract(this.value, 'hour')
        .format(this.$config.dateFormat + ' HH:00')
      return `${startTimeText} To ${nowText}`
    }
  },
  data () {
    return {
      customDateRange: []
    }
  }
}
</script>

<style lang="scss">
  .pet .hour24 {
    display: none;
  }
</style>
